/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./minetask.vue?vue&type=template&id=2b191d9e&scoped=true"
import script from "./minetask.vue?vue&type=script&lang=js"
export * from "./minetask.vue?vue&type=script&lang=js"
import style0 from "./minetask.vue?vue&type=style&index=0&id=2b191d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b191d9e",
  null
  
)

export default component.exports